import { getAddress } from "viem";
import memoize from "lodash/memoize";
import { Token, Currency, NATIVE } from "@pancakeswap/sdk";
import { ChainId } from "@pancakeswap/chains";
import { pulseTokens } from "@pancakeswap/tokens";

const mapping: { [key: number]: string } = {
};

export const getTokenLogoURL = memoize(
  (token?: Token) => {
    if (token && mapping[token.chainId]) {
      return `https://assets-cdn.trustwallet.com/blockchains/${mapping[token.chainId]}/assets/${getAddress(
        token.address
      )}/logo.png`;
    }
    return null;
  },
  (t) => `${t?.chainId}#${t?.address}`
);

export const getTokenLogoURLByAddress = memoize(
  (address?: string, chainId?: number) => {
    if (address && chainId && mapping[chainId]) {
      return `https://assets-cdn.trustwallet.com/blockchains/${mapping[chainId]}/assets/${getAddress(
        address
      )}/logo.png`;
    }
    return null;
  },
  (address, chainId) => `${chainId}#${address}`
);

const chainName: { [key: number]: string } = {
  [ChainId.PULSE]: "pulse"
};

// TODO: move to utils or token-list
export const getTokenListBaseURL = (chainId: number) =>
  `https://pdex.vision/images/${chainName[chainId]}`;

export const getTokenListTokenUrl = (token: Token) =>
  token.chainId
    ? `https://pdex.vision/images/chains/${token.chainId}.png`
    : null;

const commonCurrencySymbols = [
  pulseTokens.usdt,
  pulseTokens.usdc,
  pulseTokens.nineinch,
  // bscTokens.cake,
  // ethereumTokens.wbtc,
  // ethereumTokens.weth,
  NATIVE[ChainId.PULSE],
  // bscTokens.busd,
  // ethereumTokens.dai,
].map(({ symbol }) => symbol);

export const getCommonCurrencyUrl = memoize(
  (currency?: Currency): string | undefined => getCommonCurrencyUrlBySymbol(currency?.symbol),
  (currency?: Currency) => `logoUrls#${currency?.chainId}#${currency?.symbol}`
);

export const getCommonCurrencyUrlBySymbol = memoize(
  (symbol?: string): string | undefined =>
    symbol && commonCurrencySymbols.includes(symbol)
      ? `https://pdex.vision/images/symbols/${symbol.toLocaleLowerCase()}.png`
      : undefined,
  (symbol?: string) => `logoUrls#symbol#${symbol}`
);

export const getCurrencyLogoUrls = memoize(
  (currency?: Currency): string[] => {
    const trustWalletLogo = getTokenLogoURL(currency?.wrapped);
    const logoUrl = currency ? getTokenListTokenUrl(currency.wrapped) : null;
    return [getCommonCurrencyUrl(currency), trustWalletLogo, logoUrl].filter((url): url is string => !!url);
  },
  (currency?: Currency) => `logoUrls#${currency?.chainId}#${currency?.wrapped?.address}`
);
